import { rootNamespace } from "config";
import { useContext } from "react";
import windowMap from "windows/windows";
import { TreeContext } from "./Editor";

export default function Sidebar() {
  const { publish } = useContext(TreeContext);
  function focusTab(tab) {
    publish(rootNamespace, "FOCUS_TAB", tab);
  }
  return (
    <div className="sb">
      {Object.keys(windowMap).map((f) => {
        return (
          <div key={f} className="sb-i" onClick={() => focusTab(f)} title={f}>
            <i className={windowMap[f].icon} />
          </div>
        );
      })}
    </div>
  );
}
